package com.heelion.farmafreelance.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch

const val URL_PRIVACY = "https://farmafreelance.pages.dev/privacy"

/**
 * Ultimo passo dell'iscrizione: rimando all'informativa (i dati servono al servizio, non serve
 * un consenso) e la casella facoltativa per le email promozionali, mai preselezionata.
 */
@Composable
fun ConsensiIscrizione(marketing: Boolean, onMarketing: (Boolean) -> Unit) {
    val uriHandler = LocalUriHandler.current
    Row(
        modifier = Modifier.fillMaxWidth().clickable { onMarketing(!marketing) }.padding(vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Checkbox(checked = marketing, onCheckedChange = onMarketing)
        Text(
            "Voglio ricevere via email novità e offerte di FarmaFreelance (facoltativo, puoi cambiare idea dalle impostazioni).",
            style = MaterialTheme.typography.bodySmall
        )
    }
    TextButton(onClick = { uriHandler.openUri(URL_PRIVACY) }) {
        Text("Iscrivendoti dichiari di aver letto l'informativa sulla privacy", style = MaterialTheme.typography.bodySmall)
    }
    Spacer(Modifier.height(8.dp))
}

/** Impostazioni → consenso alle email promozionali, attivabile e revocabile in ogni momento. */
@Composable
fun SezioneConsensi(viewModel: AuthViewModel) {
    var marketing by remember { mutableStateOf<Boolean?>(null) }
    var errore by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) { marketing = viewModel.consensi()?.marketing }

    Text(
        text = "Comunicazioni",
        style = MaterialTheme.typography.titleMedium,
        color = MaterialTheme.colorScheme.primary,
        modifier = Modifier.padding(bottom = 8.dp)
    )
    Row(verticalAlignment = Alignment.CenterVertically) {
        Text(
            "Ricevi via email novità e offerte di FarmaFreelance",
            style = MaterialTheme.typography.bodyMedium,
            modifier = Modifier.weight(1f)
        )
        Switch(
            checked = marketing == true,
            enabled = marketing != null,
            onCheckedChange = { nuovo ->
                val prima = marketing
                marketing = nuovo
                errore = null
                scope.launch {
                    if (!viewModel.salvaConsensi(nuovo)) {
                        marketing = prima
                        errore = "Non è stato possibile salvare: riprova."
                    }
                }
            }
        )
    }
    errore?.let { Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall) }
}
